import { HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ProgressSelectors, useTranslation } from '@web_opxp/features';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { AssetsBaseUrl } from '../../assets';
import { CFQ_DOMAINS, MOOD_ID, SKELETON_CLASSNAME } from '../../base/constants';
import { EDomain } from '../../base/types';
import MoodTrackerWrapper from '../../components/MoodTracker/MoodTrackerWrapper';
import SideBarSection from '../../components/SideBarSection/SideBarSection';
import { GroupAdminBanner } from '../../groupAdmin';
import EvaluationSideBar from '../EvaluationSideBar';
import * as Selectors from '../selectors';
import useUserIdFromRoute from '../useUserIdFromRoute';
import DomainEvaluation from './DomainEvaluation';

export default function SelfEvaluationView() {
  const userId = useUserIdFromRoute();
  const moodProgressHistory = useSelector((s: ProgressSelectors.IAppState) =>
    ProgressSelectors.getWorkoutProgressHistory(s, MOOD_ID, userId)
  );
  const ready = useSelector(Selectors.isFeatureReady);
  const cfqPresent = useSelector(Selectors.selfAssessmentResultsPresent);
  const { language, t } = useTranslation();

  const hasMoodData = !!(moodProgressHistory && moodProgressHistory.length > 0);
  const domains = [...CFQ_DOMAINS];
  const evaluationLottie = 'Lab_Animation360';
  const loaded = ready && !!language;
  const skeletonClass = loaded ? '' : SKELETON_CLASSNAME;
  let description: string;

  if (userId) {
    description = t('Evaluation.SelfAssessments.User');
  } else if (cfqPresent) {
    description = t('Evaluation.SelfAssessments.Intro');
  } else {
    description = t('Evaluation.SelfAssessments.IntroNoData');
  }

  let cfqDomainEvaluations: ReactNode = null;
  if (cfqPresent) {
    cfqDomainEvaluations = domains.map((domain) => <DomainEvaluation domain={domain} key={domain} />);
  } else {
    cfqDomainEvaluations = <img src={`${AssetsBaseUrl}/feature/cfq/CFQ_no_data.png`} alt="no data available" />;
  }
  let moodTrackerEvaluation: ReactNode = null;
  if (hasMoodData) {
    // wrap whole section with experiment wrapper, not only the progress widget itself
    moodTrackerEvaluation = (
      <MoodTrackerWrapper>
        <DomainEvaluation domain={EDomain.Mood} />
      </MoodTrackerWrapper>
    );
  }
  const sidebar = <EvaluationSideBar />;
  return (
    <>
      <HeroSection lottie={evaluationLottie} className="evaluation-section">
        <SectionTitle className={skeletonClass}>{t('Evaluation.SelfAssessments.PageTitle')}</SectionTitle>
        <SectionSubtitle className={skeletonClass}>{description}</SectionSubtitle>
      </HeroSection>
      <GroupAdminBanner userId={userId} />

      <SideBarSection sidebar={sidebar}>
        <div className="col-2"></div>
        <div className="col-5">
          {cfqDomainEvaluations}
          {moodTrackerEvaluation}
        </div>
        <div className="col-2"></div>
      </SideBarSection>
    </>
  );
}
